import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import '../../css/generals/paper.css'
import PropTypes from 'prop-types'
import styles from '../../css/generals/Checkbox.module.css'
import stylesPreferences from '../../css/preferences/Preferences.module.css'
import { Slider } from 'primereact/slider'
import { popupSimple } from '../../components/generals/popups'
import { postData } from '../../actions/servicesHttp'
import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function ModalModifyScreenBrightness ({ show, onHide, type, title, btnError, btnSuccess, identity, socketSendActions, realTime }) {
  const { id } = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState({
    status: false,
    percentage: 1
  })
  const { t } = useTranslation('dashboardDevice')

  function closeModal () {
    onHide()
    setData({
      status: false,
      percentage: 1
    })
  }

  async function modifyScreenBrightness (data) {
    const json = {
      action: 'brightness',
      data,
      devicesId: [parseInt(id)],
      groupsId: []
    }

    if (realTime) {
      socketSendActions([json])
      popupSimple('success', t('modalModifyScreenBrightness.message1'))
    } else {
      const { data } = await postData('actions', [json], navigate)
      if (data[0]?.result) {
        popupSimple('success', t('modalModifyScreenBrightness.message1'))
        // if (data[1]?.sendings.length > 0) setDevice()
      } else {
        popupSimple('error', t('modalModifyScreenBrightness.message2'))
      }
    }
    closeModal()
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'modifyScreenBrightness'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('modalModifyScreenBrightness.label1')}</span>
                    <div className={stylesPreferences.sliderPref}>
                        <Slider
                            id="percentBrightness"
                            value={data?.percentage}
                            className={stylesPreferences.slider}
                            name="percentBrightness"
                            min={1}
                            onChange={(e) =>
                              setData({
                                ...data,
                                percentage: e.value
                              })
                            }
                        />
                        <h5 className={stylesPreferences.sliderPercentage}>{data?.percentage}%</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => modifyScreenBrightness(data)} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalModifyScreenBrightness.propTypes = {
  onHide: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  identity: PropTypes.string,
  socketSendActions: PropTypes.func,
  realTime: PropTypes.bool
}
